import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStaysProduct } from '../../utils/app-features';

/**
 * A public page that exists only with Lobbero Stays (Independent Stays IS8.0,
 * IS8-D4): the Stays sign-up and the guest's links. With Stays switched off on
 * this server the address behaves like one the app never had — the same
 * redirect to sign-in the public router gives any unmatched address. Nothing is
 * drawn until the server has answered, so neither page flashes.
 */
export const StaysOnlyRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const on = useStaysProduct();
  if (on === null) return null;
  if (!on) return <Navigate to="/" replace state={{ unmatched: true }} />;

  return children;
};
